import { useCallback } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded';

const imageWrapperStyles = {
    width: '200px',
    height: '100px',
    position: 'relative',
    '&:hover': {
        '& .show-background': {
            borderRadius: '4px',
            backgroundColor: 'black',
            opacity: 0.5,
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
        },
        '& .show-icon': {
            display: 'inline-flex',
        },
    },
    '& .image': {
        borderRadius: '4px',
    },
};

const imageIconWrapperStyles = {
    display: 'none',
    position: 'absolute',
    top: 0,
    right: 0,
};

interface Props {
    id: string;
    filePath: string;
    fileName: string;
    onView: (id: string) => void;
}

export const AttachmentViewItem = ({ id, filePath, fileName, onView }: Props) => {
    const viewImageHandler = useCallback(() => {
        onView(id);
    }, [onView]);

    return (
        <Box sx={imageWrapperStyles}>
            <img src={filePath} alt={fileName} width="100%" height="100%" className="image" />
            <Box className="show-background" />
            <IconButton sx={imageIconWrapperStyles} className="show-icon" onClick={viewImageHandler}>
                <RemoveRedEyeRoundedIcon color="primary" />
            </IconButton>
        </Box>
    );
};
